import { isEmpty } from 'lodash';
import { ApolloError } from '@apollo/client';

import { FullScreenProgress, Typography } from '@occc/ui-design-system';
import { TransactionDetailsFragment } from '@occc/graphql';
import { TransactionViewOfTransactionDetails } from '@occc-app/routes/Transactions/TransactionView/TransactionViewOfTransactionDetails';

import { TransactionPaymentInfo } from './transaction-payment-info';
import { TransactionStateChanges } from './transaction-state-changes';
import { TransactionPaymentEvents } from './transaction-payment-events';
import { errorMessage, noDataMessage } from './transaction-details.copies';

type TransactionDetailsProps = {
  transaction: TransactionDetailsFragment | null;
  loading: boolean;
  error?: ApolloError;
};

export const TransactionDetails = ({ transaction, loading, error }: TransactionDetailsProps) => {
  if (loading) {
    return <FullScreenProgress />;
  }

  if (error) {
    return (
      <Typography color='error' data-testid='something-went-wrong-msg'>
        {errorMessage}
      </Typography>
    );
  }

  if (!transaction || isEmpty(transaction)) {
    return (
      <Typography color='error' data-testid='no-data-msg'>
        {noDataMessage}
      </Typography>
    );
  }

  const paymentInfo = transaction?.paymentInfo ?? [];
  const stateChanges = transaction?.stateChanges ?? [];
  const paymentEvents = transaction?.paymentEvents ?? [];

  return (
    <>
      <TransactionViewOfTransactionDetails transaction={transaction} />
      {paymentInfo.length > 0 && <TransactionPaymentInfo paymentInfo={paymentInfo} />}
      {stateChanges.length > 0 && <TransactionStateChanges stateChanges={stateChanges} />}
      {paymentEvents.length > 0 && <TransactionPaymentEvents paymentEvents={paymentEvents} />}
    </>
  );
};
